{
  "permissionsTitle": "One last step",
  "permissionsSubtitle": "Help Opncue find people nearby and let you know when someone reaches out.",
  "locationTitle": "Location",
  "locationRequirement": "Needed for nearby features",
  "locationDescription": "Used to show people and groups near you. We don’t keep a history of where you’ve been.",
  "locationAction": "Allow location access",
  "notificationsTitle": "Notifications",
  "notificationsDescription": "Know when someone sends you a cue or message. You can change this anytime.",
  "notificationsAction": "Turn on notifications",
  "mode": {
    "title": "What brings you here?",
    "description": "This shapes who we surface first. It nudges matching — it never hard-filters anyone out.",
    "skipForNow": "Skip for now"
  },
  "profile": {
    "title": "Let’s get you set up",
    "description": "Give people a glimpse of who they’re connecting with.",
    "yourName": "Your name",
    "hereFor": "Here for: {{goals}}",
    "chooseReasonBelow": "Choose what brings you here below",
    "displayName": "Display name",
    "displayNamePlaceholder": "Sunny Harbor",
    "randomName": "Random name",
    "headline": "Headline",
    "headlinePlaceholder": "Share a short line about yourself",
    "dateOfBirth": "Date of birth",
    "dateOfBirthPlaceholder": "Select date of birth",
    "publicAgeBand": "Public age band: {{ageBand}}",
    "dateOfBirthPrivate": "Private. Used to calculate your age band.",
    "friendshipGoal": "What brings you here? (Friendship goal)",
    "friendshipGoalShort": "What brings you here?",
    "chooseOne": "Choose one. You can change this later.",
    "chooseReason": "Choose a reason",
    "customReasonPlaceholder": "Tell us what you are looking for",
    "closeGoalOptions": "Close friendship goal options",
    "goalSelectionA11y": "What brings you here: {{selection}}",
    "headlineRequired": "Add a short headline.",
    "headlineTooLong": "Use up to {{max}} characters.",
    "goalRequired": "Choose one friendship goal.",
    "minimumAge": "You need to be at least 18 to join Opncue.",
    "customGoalRequired": "Type what you are looking for first.",
    "customGoalLimit": "Use one custom friendship goal at a time.",
    "customGoalDuplicate": "That reason is already in your list."
  }
}
